export const userRolesMap = {
  admin: 'MSM-Admin',
  user: 'MSM-User',
};
